import React, { useContext, useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import { useNavigate } from "react-router";
import { postApi } from "../../services/api/globalApi";
import OTPInput from "../../components/common/otpInput/OTPInput";
import Counter from "../../components/common/counter/Counter";
import {
  errorMessage,
  successMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import { context } from "../../context/context";
import Cookies from "js-cookie";
import {
  loginValidate,
  loginValidateWithOtp,
} from "../../components/common/validations/loginValidate";

const Login = () => {
  const navigate = useNavigate();

  const { getUser,getUtils } = useContext(context);

  const [showOtp, setShowOtp] = useState(false);
  const [showCounter, setShowCounter] = useState(false);
  const [loadingSpiner, setLoadingSpiner] = useState(false);

  const [mobile, setMobile] = useState("");

  const sendOtp = async (values, { resetForm }) => {
    setMobile(values.mobile);
    setLoadingSpiner(true);
    try {
      const body = values;
      const response = await postApi({
        path: "admin/otps",
        body: body,
      });
      successMessage("کد OTP برای شما ارسال شد.");
      setShowCounter(true);
      setTimeout(() => {
        setShowCounter(false);
      }, 122000);
      setLoadingSpiner(false);
      setShowOtp(true);
      resetForm();
      console.log(response);
    } catch (error) {
      console.error(error);
      setLoadingSpiner(false);
      errorMessage(error?.response?.data?.errors[0].message);
    }
  };

  const sendOtpAgain = async () => {
    try {
      const body = { mobile: mobile };
      const response = await postApi({
        path: "admin/otps",
        body: body,
      });
      successMessage("کد OTP دوباره برای شما ارسال شد.");
      setShowCounter(true);
      setTimeout(() => {
        setShowCounter(false);
      }, 122000);
      setLoadingSpiner(false);
      console.log(response);
    } catch (error) {
      console.error(error);
      errorMessage(error?.response?.data?.errors[0].message);
    }
  };

  const login = async (values, { resetForm }) => {
    try {
      const body = JSON.stringify({ ...values, mobile: mobile });

      await postApi({
        path: "admin/auth/login",
        body: body,
      });

      successMessage("شما با موفقیت وارد شدید.");
      Cookies.set("liResponse", true, { expires: 365 });
      getUser();
      getUtils()
      resetForm();
      setShowOtp(false);
      navigate("/");
    } catch (error) {
      console.error(error);
      errorMessage(error?.response?.data?.errors[0].message);
    }
  };

  useEffect(() => {
    if (Cookies.get("liResponse")) {
      navigate("/");
    }
  }, []);

  return (
    <div className="loginBg h-screen w-screen min-h-[800px]">
      <div className="bg-black/40 w-full h-full">
        <div className="flex flex-col items-center justify-center mx-auto px-8">
          <div className="flex items-center mt-2 md:mt-4 text-2xl font-semibold text-gray-900 dark:text-white">
            <img
              className="w-60 sm:w-80 my-4 mx-auto"
              src={require("./../../assets/images/loginLogo.png")}
              alt=""
            />
          </div>
          <div className="w-full bg-white/50 mt-4 md:mt-10 backdrop-blur rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
            {!showOtp ? (
              <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                <h1 className="text-xl font-bold leading-tight b-titr text-center tracking-tight text-gray-900 md:text-2xl dark:text-white">
                  به حساب خود وارد شوید
                </h1>
                <Formik
                  initialValues={{
                    mobile: "",
                  }}
                  validationSchema={loginValidate}
                  onSubmit={sendOtp}
                >
                  {(formik) => (
                    <Form>
                      <label
                        for="mobile"
                        className="block mb-2 text-sm sm:text-lg b-titr font-medium text-gray-900 dark:text-white"
                      >
                        شماره همراه
                      </label>
                      <div className="relative">
                        <Field
                          autocomplete="off"
                          id="mobile"
                          name="mobile"
                          type="text"
                          className="peer py-3 px-4 ps-11 block w-full bg-gray-100 border-transparent rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-700 dark:border-transparent dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600"
                          placeholder="شماره همراه"
                          disabled={loadingSpiner ? "disabeld" : ""}
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                        />
                        <div className="absolute inset-y-0 start-0 flex items-center pointer-events-none ps-4 peer-disabled:opacity-50 peer-disabled:pointer-events-none">
                          <svg
                            className="flex-shrink-0 size-4 text-gray-500 dark:text-neutral-500"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                            <circle cx="12" cy="7" r="4"></circle>
                          </svg>
                        </div>
                      </div>
                      {formik.errors.mobile && formik.touched.mobile ? (
                        <p className="text-sm my-4 text-red-900 dark:text-red-400">
                          {formik.errors.mobile}
                        </p>
                      ) : null}
                      <button
                        type="submit"
                        className="w-full flex gap-x-2 items-center justify-center mt-6 text-white bg-indigo-600 hover:bg-indigo-700 focus:ring-4 focus:outline-none focus:ring-indigo-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-indigo-600 dark:hover:bg-indigo-700 dark:focus:ring-indigo-800"
                      >
                        مرحله بعد
                        {loadingSpiner && (
                          <div
                            class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-e-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                            role="status"
                          ></div>
                        )}
                      </button>
                    </Form>
                  )}
                </Formik>
              </div>
            ) : (
              <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                <h1 className="text-xl font-bold leading-tight b-titr text-center tracking-tight text-gray-900 md:text-2xl dark:text-white">
                  کد OTP ارسال شده را وارد کنید
                </h1>

                <Formik
                  initialValues={{
                    password: "",
                    code: "",
                  }}
                  validationSchema={loginValidateWithOtp}
                  onSubmit={login}
                >
                  {(formik) => (
                    <Form>
                      <div className="mb-4">
                        <OTPInput
                          onChange={(e) => formik.setFieldValue("code", e)}
                        />
                        {formik.errors.code && formik.touched.code ? (
                          <p className="text-sm my-4 text-red-900 dark:text-red-400">
                            {formik.errors.code}
                          </p>
                        ) : null}
                      </div>

                      <div className="w-full flex flex-col gap-2 mt-6 justify-center items-center">
                        <button
                          disabled={showCounter ? "disabled" : ""}
                          onClick={sendOtpAgain}
                          type="button"
                          class="flex items-center justify-center gap-x-2 focus:outline-none text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-10 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                        >
                          ارسال دوباره کد
                          {showCounter && <Counter number={120} />}
                        </button>
                      </div>

                      <div className="mt-4">
                        <div className="relative">
                          <Field
                            autocomplete="off"
                            id="password"
                            name="password"
                            type="password"
                            className="peer py-3 px-4 ps-11 block w-full bg-gray-100 border-transparent rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-700 dark:border-transparent dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600"
                            placeholder="رمز عبور"
                          />
                          <div className="absolute inset-y-0 start-0 flex items-center pointer-events-none ps-4 peer-disabled:opacity-50 peer-disabled:pointer-events-none">
                            <svg
                              className="flex-shrink-0 size-4 text-gray-500 dark:text-neutral-500"
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path d="M2 18v3c0 .6.4 1 1 1h4v-3h3v-3h2l1.4-1.4a6.5 6.5 0 1 0-4-4Z"></path>
                              <circle cx="16.5" cy="7.5" r=".5"></circle>
                            </svg>
                          </div>
                        </div>
                        {formik.errors.password && formik.touched.password ? (
                          <p className="text-sm my-4 text-red-900 dark:text-red-400">
                            {formik.errors.password}
                          </p>
                        ) : null}
                      </div>

                      <p class="mt-6 text-center text-sm flex gap-x-2 justify-center items-center text-gray-700">
                        شماره اشتباه است ؟
                        <p
                          onClick={() => setShowOtp(false)}
                          class="cursor-pointer font-semibold leading-6 text-indigo-700 hover:text-indigo-800"
                        >
                          تعویض شماره
                        </p>
                      </p>

                      <button
                        type="submit"
                        className="flex flex-col justidy-center items-center w-10/12 block mx-auto mt-6 text-white bg-indigo-600 hover:bg-indigo-700 focus:ring-4 focus:outline-none focus:ring-indigo-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-indigo-600 dark:hover:bg-indigo-700 dark:focus:ring-indigo-800"
                      >
                        ورود
                        {loadingSpiner && (
                          <div
                            class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-e-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                            role="status"
                          ></div>
                        )}
                      </button>
                    </Form>
                  )}
                </Formik>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
